import { render, staticRenderFns } from "./About.vue?vue&type=template&id=02f1cc6c&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=02f1cc6c&scoped=true&lang=css&"
import style1 from "@/assets/css/common.css?vue&type=style&index=1&id=02f1cc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f1cc6c",
  null
  
)

export default component.exports